import type { DateTime } from 'luxon';

/**
 * Adds a specified number of business days to a date, excluding weekends (Saturday and Sunday).
 * @param date - The starting date
 * @param days - The number of business days to add
 * @returns A new DateTime object with the business days added
 */
export function addBusinessDays(date: DateTime, days: number): DateTime {
  if (days < 0) {
    throw new Error('Days must be non-negative');
  }

  let currentDate = date;
  let daysAdded = 0;

  while (daysAdded < days) {
    currentDate = currentDate.plus({ days: 1 });
    // Skip weekends (Saturday = 6, Sunday = 7)
    const weekday = currentDate.weekday;
    if (weekday !== 6 && weekday !== 7) {
      daysAdded++;
    }
  }

  return currentDate;
}

export function calcBusinessDaysDifference(startDate: DateTime, endDate: DateTime): number {
  if (endDate < startDate) {
    return 0;
  }

  let currentDate = startDate.startOf('day');
  const targetDate = endDate.startOf('day');
  let businessDays = 0;

  // Start from the day after startDate and count until we reach targetDate
  currentDate = currentDate.plus({ days: 1 });
  while (currentDate <= targetDate) {
    const weekday = currentDate.weekday;
    // Skip weekends (Saturday = 6, Sunday = 7)
    if (weekday !== 6 && weekday !== 7) {
      businessDays++;
    }
    currentDate = currentDate.plus({ days: 1 });
  }

  return businessDays;
}
